import React, { useRef } from "react";
import { useInView } from "framer-motion";
import { cn } from "@/lib/utils";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

const LogoSlider = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.1 });
  const logos = [
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a316af40a683b64fe810b05.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a316af40a683b64fe810b0a.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a316af40c03f3dfbe67696b.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a316af4889260003894649b.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a316ac00c03f3dfbe67645e.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a3160ffc87bd94b121d232b.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a3160d722582c14f1224f4e.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a31607e6dd61c546ac57080.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a31615ddd7879239a2f03a7.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a316197c87bd94b121d313f.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a3161be6dd61c546ac599c1.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a3161df22582c14f1226c03.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a31670e6dd61c546ac62c15.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a3166d46dd61c546ac62648.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a31669ea20786fa2d77f1ab.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a316205602476018d5226e4.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a316731602476018d52b820.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a31674fdd7879239a2fc2c0.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a3167fc0c03f3dfbe657004.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a3168191b95dbb2c2265fa5.webp",
    "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a316832dd7879239a3024d4.webp",
  ];

  return (
    <div
      ref={ref}
      className="bg-white py-12 border-y border-border overflow-hidden min-h-[300px]"
    >
      <div className="container mx-auto px-4 mb-8">
        <p className="text-center text-muted-foreground font-semibold uppercase tracking-widest mb-2 text-lg">
          Clientes que confiam no nosso trabalho
        </p>
      </div>
      {isInView && (
        <div className="max-w-[1250px] mx-auto px-4 md:px-24 lg:px-32 relative pb-20 md:pb-0">
          <Carousel
            opts={{
              align: "start",
              dragFree: true,
              loop: true,
            }}
            className="w-full"
          >
            <CarouselContent className="-ml-4 md:-ml-8 py-8">
              {logos.map((logo, index) => (
                <CarouselItem key={index} className="pl-4 md:pl-8 basis-auto">
                  <img
                    src={logo}
                    alt={`Avaliação Cliente ${index}`}
                    loading="lazy"
                    decoding="async"
                    className="h-auto w-[320px] md:w-[450px] shrink-0 object-contain transition-all duration-300 transform hover:scale-105 rounded-md shadow-sm"
                  />
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="flex top-auto bottom-[-60px] md:bottom-auto md:top-1/2 translate-y-0 md:-translate-y-1/2 left-[35%] md:-left-20 lg:-left-20 -translate-x-1/2 md:translate-x-0 h-12 w-12 md:h-16 md:w-16 bg-white border-2 border-primary text-primary hover:bg-primary hover:text-white shadow-xl transition-colors z-10" />
            <CarouselNext className="flex top-auto bottom-[-60px] md:bottom-auto md:top-1/2 translate-y-0 md:-translate-y-1/2 right-[35%] md:-right-20 lg:-right-20 translate-x-1/2 md:translate-x-0 h-12 w-12 md:h-16 md:w-16 bg-white border-2 border-primary text-primary hover:bg-primary hover:text-white shadow-xl transition-colors z-10" />
          </Carousel>
        </div>
      )}
    </div>
  );
};

export default LogoSlider;
